module.exports = __webpack_public_path__ + "img/经验丰富.4d55665a.jpg";